import { createRouter, createWebHistory } from 'vue-router'
import {checkSession, redirectIfLogger} from "@/utils/utils.js";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/LoginView.vue'),
      beforeEnter: async () => {
        await redirectIfLogger();
      }
    },
    {
      path: '/testeaza-gratuit',
      name: 'testeaza-gratuit',
      component: () => import('../views/TesteazaView.vue'),
      beforeEnter: async () => {
        let isInIframe = false;
        try {
          isInIframe = window.self !== window.top
        } catch (e) {
          isInIframe = true;
        }
        if (!isInIframe) {
          await redirectIfLogger();
        }
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/LoginView.vue'),
      beforeEnter: async () => {
        await redirectIfLogger();
      }
    },
    {
      path: '/inregistrare',
      name: 'inregistrare',
      component: () => import('../views/SignUpView.vue'),
      beforeEnter: async () => {
        await redirectIfLogger();
      }
    },
    {
      path: '/recuperare-parola',
      name: 'recuperare-parola',
      component: () => import('../views/RecoverPasswordView.vue'),
      beforeEnter: async () => {
        await redirectIfLogger();
      }
    },
    {
      path: '/meniuri',
      name: 'meniuri',
      component: () => import('../views/MeniuriView.vue'),
      beforeEnter: async () => {
        await checkSession();
      },
    },
    {
      path: '/profil',
      name: 'profil',
      component: () => import('../views/ProfileView.vue'),
      beforeEnter: async () => {
        await checkSession();
      },
    },
    {
      path: '/parola-noua',
      name: 'parola-noua',
      component: () => import('../views/ResetPasswordView.vue'),
      beforeEnter: async () => {
        await redirectIfLogger();
      },
    },
    {
      path: '/success',
      name: 'success',
      component: () => import('../views/PaymentSuccessView.vue'),
      beforeEnter: async () => {
        await redirectIfLogger();
      },
    },
    {
      path: '/failed',
      name: 'failed',
      component: () => import('../views/PaymentFailedView.vue'),
      beforeEnter: async () => {
        await redirectIfLogger();
      },
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import('../views/AdminView.vue'),
      beforeEnter: async () => {
        await checkSession();
      },
    },
    {
      path: '/politica-de-confidentialitate',
      name: 'politica-de-confidentialitate',
      component: () => import('../views/Confidentialitate.vue'),
      beforeEnter: async () => {
      },
    },
    {
      path: '/termeni-si-conditii',
      name: 'termeni-si-conditii',
      component: () => import('../views/Termeni.vue'),
      beforeEnter: async () => {
      },
    },
  ],
})

export default router
